import
  React
from 'react';

import
  styled, {
  keyframes,
} from 'styled-components';

import {
  Colors,
  FontFamilies,
  FontSizes,
  Theme
} from 'common';

const Container = styled.div`
  display: flex;
  flex-direction: ${props => props.flexDirection || 'row'};
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: ${props => props.fontSize || FontSizes.Small};
  height: ${props => props.height || '40px'};
  border-radius: ${props => props.borderRadius || '10px'};
  width: ${props => props.width || '250px'};
  user-select: none;
  font-family: ${props => props.fontFamily || FontFamilies.Regular};

  ${props => props.margin && `margin: ${props.margin};`}
  ${props => props.border && `border: ${props.border};`}
  ${props => props.padding && `padding: ${props.padding};`}
  ${props => props.minWidth && `min-width: ${props.minWidth};`}
  ${props => props.maxWidth && `max-width: ${props.maxWidth};`}
  ${props => props.minHeight && `min-height: ${props.minHeight};`}
  ${props => props.maxHeight && `max-height: ${props.maxHeight};`}

  background-color: ${props => !props.disabled
    ? props.backgroundColor || Colors.PrimaryOne
    : Theme.Button.Disabled.Background};

    color: ${props => !props.disabled
      ? props.textColor || Colors.White
      : Colors.Black};

  -webkit-tap-highlight-color: rgba(0,0,0,0);
  -webkit-tap-highlight-color: transparent;
`;

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const SimpleLoader = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid ${props => props.loaderColor || Colors.White};
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: transparent;
  border-radius: 50%;
  animation: ${spin} 0.6s linear infinite;
`;

export const Button = props => {

  const onClick = () => {

    if (props.disabled || props.showLoading) {
      return;
    }

    typeof props.onClick === 'function' && props.onClick();
  };

  return (

    <Container
      backgroundColor={props.backgroundColor}
      textColor={props.textColor}
      flexDirection={props.flexDirection}
      height={props.height}
      width={props.width}
      minWidth={props.minWidth}
      maxWidth={props.maxWidth}
      minHeight={props.minHeight}
      maxHeight={props.maxHeight}
      fontFamily={props.fontFamily}
      fontSize={props.fontSize}
      border={props.border}
      borderRadius={props.borderRadius}
      margin={props.margin}
      padding={props.padding}
      disabled={props.disabled}
      onClick={onClick}>

        { props.showLoading

          ? <SimpleLoader loaderColor={props.textColor || Colors.White} />

          : props.text || props.children || ''
        }

    </Container>
  );
};